import { checkout } from "../data/content";
export function checkoutUrl() {
  const url = new URL(checkout.url);
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","utm_id","fbclid","gclid","ttclid","msclkid","src","sck"].forEach(key => {
      const value = params.get(key);
      if (value) url.searchParams.set(key,value);
    });
  }
  return url.toString();
}
